import { useTranslation } from 'react-i18next'
import { setLanguage, getLanguage, type Lang } from './index'

export const useLanguage = (): { lang: Lang; setLang: (lang: Lang) => void } => {
  useTranslation()
  return { lang: getLanguage(), setLang: setLanguage }
}
